import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { select, Action, Store } from '@ngrx/store';
import { AppetiteActionTypes } from '../actions';
import {
    ProductActionTypes,
    SetProductsStatusAction,
} from '../../products-store/actions';
import { catchError, map, mergeMap, tap, switchMap } from 'rxjs/operators';
import { Classification } from '../../../model/classification';
import { ZipcodeModel } from '../../../model/zipcode';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { PartnerCustomization } from '../../../partner-customization/partner-customization.helper';
import { reject } from 'lodash-es';
import { Product } from '../../../model/product';
import { CommonCommunicationService } from '../../../services/common-communication.service';
import { AnalyticsService } from '../../../services/analytics.service';
import { isNil, isEmpty } from 'lodash-es';
@Injectable()
export class AppetiteEffects {
    classification: Observable<Classification>;
    zipcodeData: Observable<ZipcodeModel[]>;
    revenue: Observable<number>;
    startQuote: Observable<boolean>;
    WSGProductApi: string = environment.backend + environment.uri.products;
    products: Product[];
    public productStatus: string;
    state: any;
    excludeWorkCompStates: any[] = environment.excludeWorkCompStates;
    constructor(
        private _action: Actions,
        private _http: HttpClient,
        private _ccs: CommonCommunicationService,
        private _analytics: AnalyticsService,
        private _store: Store<{
            classification: Classification;
            zipcode: ZipcodeModel[];
            revenue: number;
            startQuote: boolean;
        }>,
        private _partnerCustomization: PartnerCustomization
    ) {
        this.classification = this._store.pipe(select('classification'));
        this.zipcodeData = this._store.pipe(select('zipcode'));
        this.revenue = this._store.pipe(select('revenue'));
        this.startQuote = this._store.pipe(select('startQuote'));
    }

    /**
     * Start quote effect which will trigger set product action from products store
     */
    getProducts$ = createEffect(() =>
        this._action.pipe(ofType(AppetiteActionTypes.StartQuote)).pipe(
            mergeMap((action) =>
                this._http
                    .post<any>(
                        this.WSGProductApi.replace(
                            '#PARTNER#',
                            action['partner'] ? action['partner'] : '0'
                        ),
                        action['payload']
                    )
                    .pipe(
                        tap(
                            (rawProductsFromService) => {
                                rawProductsFromService = {
                                    products: [
                                        {
                                            productId: 'BOP',
                                            productSourceSystem: 'SCI',
                                            productGroup: 'BOP',
                                            orderNumber: 2,
                                            workflowOrder: 2,
                                            name: 'Business Owners Policy',
                                            descriptions: [
                                                'General Liability',
                                                'Lost Income Insurance',
                                                'Business Property Insurance',
                                            ],
                                            oneLiner:
                                                ' A complete policy that adapts to all your small business needs.',
                                            isFeature: true,
                                            isPromotional: false,
                                            productColor: 'aqua',
                                            triaDisclosure: true,
                                            productPackages: [
                                                {
                                                    packageName: 'Silver',
                                                    displayName: 'Basic',
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $15,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Landlords only',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                                {
                                                    packageName: 'Gold',
                                                    displayName: 'Advanced',
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $35,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                                {
                                                    packageName: 'Platinum',
                                                    displayName: 'Ultimate',
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $75,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: 'Up to $50,000',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: 'Up to $50,000',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                            ],
                                            coverageAndLimits: [
                                                {
                                                    coverage:
                                                        'Occurrence Limit',
                                                    coverageCd: 'LBMED',
                                                    limitAppliesToCd: 'PerOcc',
                                                    defaultValue: '1000000',
                                                    isOptional: false,
                                                    values: [
                                                        {
                                                            value: '300000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '600000',
                                                                    values: [
                                                                        '600000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '600000',
                                                                    values: [
                                                                        '600000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '500000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '1000000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '2000000',
                                                                    values: [
                                                                        '2000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '2000000',
                                                                    values: [
                                                                        '2000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '2000000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '4000000',
                                                                    values: [
                                                                        '4000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '4000000',
                                                                    values: [
                                                                        '4000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Business Personal Property',
                                                    coverageCd: 'BPP',
                                                    isOptional: false,
                                                    values: null,
                                                    minValue: '0',
                                                    maxValue: '250000',
                                                },
                                            ],
                                        },
                                        {
                                            productId: 'GL',
                                            productSourceSystem: 'SCI',
                                            productGroup: 'BOP',
                                            orderNumber: 4,
                                            workflowOrder: 4,
                                            name: 'General Liability',
                                            descriptions: [
                                                'Bodily Injury',
                                                'Third party property',
                                                'Lawsuits',
                                            ],
                                            oneLiner:
                                                'A complete policy that adapts to all your small business needs.',
                                            isFeature: false,
                                            isPromotional: false,
                                            productColor: 'aqua',
                                            triaDisclosure: true,
                                            productPackages: [
                                                {
                                                    packageName: 'Silver',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Landlords only',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: [
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $15,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                    ],
                                                },
                                                {
                                                    packageName: 'Gold',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Up to $1,000,000',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Included',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: '',
                                                            value: '',
                                                        },
                                                        {
                                                            name: '',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: [
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $35,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                    ],
                                                },
                                                {
                                                    packageName: 'Platinum',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Up to $1,000,000',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Included',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: 'Up to $50,000',
                                                            value: 'Up to $50,000',
                                                        },
                                                        {
                                                            name: 'Up to $50,000',
                                                            value: 'Up to $50,000',
                                                        },
                                                    ],
                                                    upgradeCoverages: [
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $75,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                    ],
                                                },
                                            ],
                                            coverageAndLimits: [
                                                {
                                                    coverage:
                                                        'Occurrence Limit',
                                                    coverageCd: 'LBMED',
                                                    limitAppliesToCd: 'PerOcc',
                                                    defaultValue: '1000000',
                                                    isOptional: false,
                                                    values: [
                                                        {
                                                            value: '300000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '600000',
                                                                    values: [
                                                                        '600000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '600000',
                                                                    values: [
                                                                        '600000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '500000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '1000000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '2000000',
                                                                    values: [
                                                                        '2000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '2000000',
                                                                    values: [
                                                                        '2000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '2000000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Aggregate Limit (Excluding Products & Completed Operations)',
                                                                    limitAppliesToCd:
                                                                        'Aggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '4000000',
                                                                    values: [
                                                                        '4000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Products & Completed Operations',
                                                                    limitAppliesToCd:
                                                                        'ProductsCompletedAggregate',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '4000000',
                                                                    values: [
                                                                        '4000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Medical Expenses',
                                                                    limitAppliesToCd:
                                                                        'PerPerson',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '5000',
                                                                    values: [
                                                                        '5000',
                                                                        '10000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            productId: 'UMBRELLA',
                                            productSourceSystem: 'SCI',
                                            productGroup: 'BOP',
                                            orderNumber: 5,
                                            workflowOrder: 5,
                                            name: 'Umbrella',
                                            descriptions: [
                                                'Expanded liability coverage',
                                                'Additional funds for claims',
                                                'Minimizes out-of-pocket expenses',
                                            ],
                                            oneLiner:
                                                ' A complete policy that adapts to all your small business needs.',
                                            isFeature: false,
                                            isPromotional: false,
                                            productColor: 'aqua',
                                            triaDisclosure: true,
                                            productPackages: [
                                                {
                                                    packageName: 'Silver',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $15,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Landlords only',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                                {
                                                    packageName: 'Gold',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $35,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: '',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: '',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                                {
                                                    packageName: 'Platinum',
                                                    displayName: null,
                                                    coverages: [
                                                        {
                                                            name: 'Liability Insurance',
                                                            value: 'Up to $1,000,000',
                                                        },
                                                        {
                                                            name: 'Property Insurance',
                                                            value: 'Up to $75,000',
                                                        },
                                                        {
                                                            name: 'Business Income Insurance',
                                                            value: 'Up to $250,000',
                                                        },
                                                        {
                                                            name: 'Additional Insureds',
                                                            value: 'Blanket',
                                                        },
                                                        {
                                                            name: 'Hired & Non-Owned Auto',
                                                            value: 'Included',
                                                        },
                                                        {
                                                            name: 'Employment Practices',
                                                            value: 'Up to $50,000',
                                                        },
                                                        {
                                                            name: 'Data Breaches',
                                                            value: 'Up to $50,000',
                                                        },
                                                    ],
                                                    upgradeCoverages: null,
                                                },
                                            ],
                                            coverageAndLimits: [
                                                {
                                                    coverage:
                                                        'Commercial Umbrella Limit',
                                                    coverageCd: 'UmbrellaLimit',
                                                    limitAppliesToCd: 'PerOcc',
                                                    defaultValue: '1000000',
                                                    isOptional: false,
                                                    values: [
                                                        {
                                                            value: '1000000',
                                                            subCoverage: null,
                                                        },
                                                        {
                                                            value: '2000000',
                                                            subCoverage: null,
                                                        },
                                                        {
                                                            value: '3000000',
                                                            subCoverage: null,
                                                        },
                                                        {
                                                            value: '4000000',
                                                            subCoverage: null,
                                                        },
                                                        {
                                                            value: '5000000',
                                                            subCoverage: null,
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            productId: 'WORKCOMP',
                                            productSourceSystem: 'SCI',
                                            productGroup: 'WC',
                                            orderNumber: 6,
                                            workflowOrder: 6,
                                            name: "Workers' Compensation",
                                            descriptions: [
                                                'Employee Medical Expenses',
                                                'Wage Replacement',
                                                'Employer’s Liability',
                                            ],
                                            oneLiner:
                                                ' A complete policy that adapts to all your small business needs.',
                                            isFeature: true,
                                            isPromotional: false,
                                            productColor: 'aqua',
                                            triaDisclosure: true,
                                            coverageAndLimits: [
                                                {
                                                    coverage:
                                                        'Occurrence Limit',
                                                    coverageCd: null,
                                                    limitAppliesToCd: 'PerAcc',
                                                    defaultValue: '500000',
                                                    isOptional: false,
                                                    values: [
                                                        {
                                                            value: '100000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Employee Limit',
                                                                    limitAppliesToCd:
                                                                        'DisEachEmpl',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '100000',
                                                                    values: [
                                                                        '100000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Bodily Injury',
                                                                    limitAppliesToCd:
                                                                        'DisPol',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '500000',
                                                                        '1000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '500000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Employee Limit',
                                                                    limitAppliesToCd:
                                                                        'DisEachEmpl',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '500000',
                                                                    values: [
                                                                        '500000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Bodily Injury',
                                                                    limitAppliesToCd:
                                                                        'DisPol',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '500000',
                                                                        '1000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: '1000000',
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Employee Limit',
                                                                    limitAppliesToCd:
                                                                        'DisEachEmpl',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                                {
                                                                    coverage:
                                                                        'Bodily Injury',
                                                                    limitAppliesToCd:
                                                                        'DisPol',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                        {
                                            productId: 'CYBER-ERM',
                                            productSourceSystem: 'SCI',
                                            productGroup: 'CYBER',
                                            orderNumber: 8,
                                            workflowOrder: 8,
                                            name: 'Cyber ERM',
                                            descriptions: [
                                                'Lost Income: Cyber Attack',
                                                'Payment Card Loss',
                                                'Regulatory Proceedings',
                                            ],
                                            oneLiner:
                                                'Handy insurance for today’s digital age.',
                                            isFeature: true,
                                            isPromotional: false,
                                            productColor: 'green',
                                            triaDisclosure: false,
                                            coverageAndLimits: [
                                                {
                                                    coverage: 'Limit Selection',
                                                    coverageCd: 'CyberLimit',
                                                    limitAppliesToCd: 'PLCYLMT',
                                                    isOptional: false,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Policy Limits',
                                                                    limitAppliesToCd:
                                                                        'DisLimit',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '1000000',
                                                                        '2000000',
                                                                        '3000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'DisRetention',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Waiting Period',
                                                                    limitAppliesToCd:
                                                                        'DisWait',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        '8',
                                                                    values: [
                                                                        '8',
                                                                        '12',
                                                                        '15',
                                                                        '18',
                                                                        '24',
                                                                        '36',
                                                                        '48',
                                                                        '60',
                                                                        '72',
                                                                        '96',
                                                                        '120',
                                                                        '168',
                                                                        '240',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Cyber Incident Response Fund Side Car',
                                                                    limitAppliesToCd:
                                                                        'DisInc',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        'Standard Coverage',
                                                                    values: [
                                                                        'Standard Coverage',
                                                                        'Affected Persons Side-Car',
                                                                        'Full CIRF Side-Car',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Protected Information Coinsurance',
                                                                    limitAppliesToCd:
                                                                        'DisCoinsurance',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        'No, do not include',
                                                                    values: [
                                                                        'Yes, include coinsurance',
                                                                        'No, do not include',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Number Of Affected Persons',
                                                                    limitAppliesToCd:
                                                                        'DisNoPersons',
                                                                    isOptional: false,
                                                                    defaultValue:
                                                                        null,
                                                                    values: null,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Cyber Incident Response Fund',
                                                    coverageCd: 'CIRF',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Business Interruption & Extra Expenses',
                                                    coverageCd: 'BIEE',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Waiting Period',
                                                                    limitAppliesToCd:
                                                                        'WaitingPeriod',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '12',
                                                                    values: [
                                                                        '12',
                                                                        '15',
                                                                        '18',
                                                                        '24',
                                                                        '36',
                                                                        '48',
                                                                        '60',
                                                                        '72',
                                                                        '96',
                                                                        '120',
                                                                        '168',
                                                                        '240',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Contingent Business Interruption & Extra Expenses',
                                                    coverageCd: 'CBILEE',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Waiting Period',
                                                                    limitAppliesToCd:
                                                                        'WaitingPeriod',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '12',
                                                                    values: [
                                                                        '12',
                                                                        '15',
                                                                        '18',
                                                                        '24',
                                                                        '36',
                                                                        '48',
                                                                        '60',
                                                                        '72',
                                                                        '96',
                                                                        '120',
                                                                        '168',
                                                                        '240',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Digital Data Recovery',
                                                    coverageCd: 'DDRY',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Network Extortion',
                                                    coverageCd: 'NTEX',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Cyber, Privacy and Network Security Liability',
                                                    coverageCd: 'CPNSL',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retroactive Date',
                                                                    limitAppliesToCd:
                                                                        'Date',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        null,
                                                                    values: null,
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Full Prior Acts',
                                                                    limitAppliesToCd:
                                                                        'PriorActs',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        'Yes',
                                                                    values: [
                                                                        'Yes',
                                                                        'No',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Payment Card Loss Sublimit',
                                                    coverageCd: 'PCLS',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Regulatory Proceeding Sublimit',
                                                    coverageCd: 'REGP',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Electronic, Social, and Printed Media Liability',
                                                    coverageCd: 'ESPL',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000000',
                                                                    values: [
                                                                        '10000',
                                                                        '25000',
                                                                        '50000',
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '350000',
                                                                        '500000',
                                                                        '1000000',
                                                                        '1500000',
                                                                        '2000000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retroactive Date',
                                                                    limitAppliesToCd:
                                                                        'Date',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        null,
                                                                    values: null,
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Full Prior Acts',
                                                                    limitAppliesToCd:
                                                                        'PriorActs',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        'Yes',
                                                                    values: [
                                                                        'Yes',
                                                                        'No',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage: 'Computer Fraud',
                                                    coverageCd: 'COMF',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '250000',
                                                                    values: [
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '500000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Funds Transfer Fraud',
                                                    coverageCd: 'FTRF',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '250000',
                                                                    values: [
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '500000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    coverage:
                                                        'Social Engineering Fraud',
                                                    coverageCd: 'SEGF',
                                                    isOptional: true,
                                                    values: [
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Coverage Limit',
                                                                    limitAppliesToCd:
                                                                        'Limit',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '250000',
                                                                    values: [
                                                                        '100000',
                                                                        '150000',
                                                                        '250000',
                                                                        '500000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            value: null,
                                                            subCoverage: [
                                                                {
                                                                    coverage:
                                                                        'Retention',
                                                                    limitAppliesToCd:
                                                                        'Retention',
                                                                    isOptional: true,
                                                                    defaultValue:
                                                                        '1000',
                                                                    values: [
                                                                        '1000',
                                                                        '1500',
                                                                        '2500',
                                                                        '5000',
                                                                        '10000',
                                                                        '15000',
                                                                        '25000',
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                    requestId:
                                        '5759ffad-7591-433e-94a3-bf3f0067676e',
                                    status: 'Success',
                                    messageType: 'Information',
                                    messageText: null,
                                };
                                this.productStatus =
                                    rawProductsFromService.status;
                                this._store.dispatch(
                                    new SetProductsStatusAction(
                                        this.productStatus
                                    )
                                );

                                if (
                                    rawProductsFromService.status &&
                                    rawProductsFromService.status ===
                                        'Failure' &&
                                    rawProductsFromService.messageText
                                ) {
                                    //GA Event to track products returned
                                    if (
                                        rawProductsFromService.products &&
                                        (isNil(
                                            rawProductsFromService.products
                                        ) ||
                                            isEmpty(
                                                rawProductsFromService.products
                                            ) ||
                                            rawProductsFromService.products
                                                .length === 0)
                                    ) {
                                        this._analytics.eventTrack.next({
                                            category: 'API Performance',
                                            action: 'Appetite API - SUCCESS',
                                            label:
                                                'TTS: ' +
                                                action['payload'][
                                                    'digitalClassCode'
                                                ] +
                                                '; STATE: ' +
                                                action['payload']['stateId'] +
                                                ';  REVENUE: ' +
                                                action['payload'][
                                                    'annualRevenue'
                                                ] +
                                                '; PRODUCTS: ' +
                                                rawProductsFromService.messageText,
                                        });
                                    } else {
                                        this._analytics.eventTrack.next({
                                            category: 'API Performance',
                                            action: 'Appetite API - FAILURE',
                                            label:
                                                'TTS: ' +
                                                action['payload'][
                                                    'digitalClassCode'
                                                ] +
                                                '; STATE: ' +
                                                action['payload']['stateId'] +
                                                ';  REVENUE: ' +
                                                action['payload'][
                                                    'annualRevenue'
                                                ] +
                                                '; ERROR: ' +
                                                (rawProductsFromService.messageText
                                                    ? rawProductsFromService.messageText
                                                    : ''),
                                        });
                                    }
                                }

                                /**
                                 * For certain scenarios, products are getting as null,
                                 * convert them to empty array
                                 */
                                if (rawProductsFromService.products == null) {
                                    this.products = [];
                                } else {
                                    this.products =
                                        rawProductsFromService.products;
                                    let sciProducts = this.products.filter(
                                        (product) => {
                                            return (
                                                product.productSourceSystem ===
                                                'SCI'
                                            );
                                        }
                                    );
                                    //GA Event to track products returned
                                    this._analytics.eventTrack.next({
                                        category: 'API Performance',
                                        action: 'Appetite API - SUCCESS',
                                        label:
                                            'TTS: ' +
                                            action['payload'][
                                                'digitalClassCode'
                                            ] +
                                            '; STATE: ' +
                                            action['payload']['stateId'] +
                                            ';  REVENUE: ' +
                                            action['payload']['annualRevenue'] +
                                            '; PRODUCTS: ' +
                                            this.convertArrayItemsToString(
                                                sciProducts,
                                                'productId'
                                            ),
                                    });
                                }

                                if (this.products.length > 0) {
                                    let excludeWC = false;
                                    this.readZipcodeFromStore$().subscribe(
                                        (zipcode) => {
                                            this.state =
                                                zipcode[0]['StateProvince'];
                                        }
                                    );
                                    this.excludeWorkCompStates.forEach(
                                        (exState) => {
                                            if (exState === this.state) {
                                                excludeWC = true;
                                            }
                                        }
                                    );
                                    this.products = reject(
                                        this.products,
                                        (product) => {
                                            return (
                                                product.productId ===
                                                    'WORKCOMP' && excludeWC
                                            );
                                        }
                                    );
                                }

                                /* Temporary patch to add featured indicator in incoming products,
                            this has to be removed when API starts returning the featured flag */

                                this.products.forEach((product, index) => {
                                    /**
                                     * Patch to test if unique workfloworder works
                                     */
                                    // if (product.productId === 'BOP') {
                                    //     product.workflowOrder = 1;
                                    // } else if (
                                    //     product.productId === 'MICROBOP'
                                    // ) {
                                    //     product.workflowOrder = 2;
                                    // } else if (
                                    //     product.productId === 'MICROCYBER'
                                    // ) {
                                    //     product.workflowOrder = 6;
                                    // } else if (
                                    //     product.productId === 'MICROMPL'
                                    // ) {
                                    //     product.workflowOrder = 7;
                                    // } else if (
                                    //     product.productId === 'UMBRELLA'
                                    // ) {
                                    //     product.workflowOrder = 9;
                                    // } else if (product.productId === 'GL') {
                                    //     product.workflowOrder = 10;
                                    // } else if (
                                    //     product.productId === 'MICROGL'
                                    // ) {
                                    //     product.workflowOrder = 11;
                                    // }
                                    product.issuanceAttempted = false;
                                    if (product['isFeature'] !== undefined) {
                                        product['featured_ind'] =
                                            product['isFeature'];
                                    }
                                    const add_property: {
                                        [k: string]: any;
                                    } = {};
                                    add_property.amount = '';
                                    add_property.forPackage = '';
                                    add_property.selected = false;
                                    product['add_property'] = add_property;
                                    if (
                                        product.productId === 'MICROGL' ||
                                        product.productId === 'GL'
                                    ) {
                                        product.include_property = true;
                                    }
                                    if (product.productId === 'CYBER-PROERM') {
                                        product.addCyberProduct = false;
                                    }
                                });
                            },
                            (error) => {
                                //GA Event to track when no response
                                this._analytics.eventTrack.next({
                                    category: 'API Performance',
                                    action: 'Appetite API - FAILURE',
                                    label:
                                        'TTS: ' +
                                        action['payload']['digitalClassCode'] +
                                        '; STATE: ' +
                                        action['payload']['stateId'] +
                                        ';  REVENUE: ' +
                                        action['payload']['annualRevenue'] +
                                        '; ERROR: Time Out',
                                });
                                this.productStatus = 'API Failure';
                                this._store.dispatch(
                                    new SetProductsStatusAction(
                                        this.productStatus
                                    )
                                );
                            }
                        ),
                        map(() => ({
                            type: ProductActionTypes.setProducts,
                            payload: this.products,
                        })),
                        catchError(() =>
                            of({
                                type: ProductActionTypes.setProductsError,
                                payload: [],
                            })
                        )
                    )
            )
        )
    );

    /**
     * Read the Classification
     */
    readClassificationFromStore$(): Observable<Classification> {
        return this.classification;
    }

    /**
     * Read the zipcode object
     */
    readZipcodeFromStore$(): Observable<ZipcodeModel[]> {
        return this.zipcodeData;
    }

    /**
     * Read Revenue from store
     */
    readRevenueFromStore$(): Observable<number> {
        return this.revenue;
    }

    /**
     * Read start quote flag from store to check start quote is triggered
     */
    readStartQuoteFlag$(): Observable<boolean> {
        return this.startQuote;
    }

    convertArrayItemsToString = (array, prop) => {
        let output = '';
        array.forEach((item) => {
            if (output) {
                output += ',' + item[prop];
            } else {
                output += item[prop];
            }
        });
        return output;
    };
}
